<!--EN SERVICE-->
<ng-container *ngIf="installations">
<table class="table table-bordered table-sm table-hover" id="en_service">
    <thead>
        <th (click)="sortby('numero_serie')" scope="col">Numéro de série</th>
        <th (click)="sortby('nom_installation')" scope="col">Nom installation</th>
        <th (click)="sortby('societe_proprietaire_raison_sociale')" scope="col">Société</th>
        <th (click)="sortby('adresse_code_postal')" scope="col">Code Postal</th>
        <th (click)="sortby('adresse_ville')" scope="col">Adresse</th>
        <th (click)="sortby('adresse_pays')" scope="col">Pays</th>
        <th (click)="sortby('date_mise_en_service')" scope="col">Date de mise en service</th>
        <th (click)="sortby('date_installation')">Date d'installation</th>
    </thead>
    <tbody>
        <tr (click)="onClickMachine(installation.id_installation)" *ngFor="let installation of installations.en_service">
            <td>{{installation.numero_serie}}</td>
            <td>{{installation.nom_installation}}</td>
            <td>{{installation.societe_proprietaire_raison_sociale}}</td>
            <td>{{installation.adresse_code_postal}}</td>
            <td>{{installation.adresse_ville}}</td>
            <td>{{installation.adresse_pays}}</td>
            <td>{{installation.date_mise_en_service}}</td>
            <td>{{installation.date_installation}}</td>
        </tr>
    </tbody>
</table>
</ng-container>
